import { Instant } from "@js-joda/core";
import { create } from "zustand";

interface ChartInDialogState {
  isDialogVisible: boolean;
  dateFrom: Instant | null;
  dateTo: Instant | null;
  header: string | null;
  identifier: string | null;
  identifiers: string[] | null;
  setDialogVisibility: (isVisible: boolean) => void;
  setDateFrom: (instant: Instant | null | undefined) => void;
  setDateTo: (instant: Instant | null | undefined) => void;
  setHeader: (header: string | null) => void;
  setIdentifier: (identifier: string | null) => void;
  setIdentifiers: (identifiers: string[] | null) => void;
}

const useChartInDialogStore = create<ChartInDialogState>(set => ({
  isDialogVisible: false,
  dateFrom: null,
  dateTo: null,
  header: null,
  identifier: null,
  identifiers: null,
  setDialogVisibility: isVisible => set({ isDialogVisible: isVisible }),
  setDateFrom: instant => set({ dateFrom: instant }),
  setDateTo: instant => set({ dateTo: instant }),
  setHeader: header => set({ header }),
  setIdentifier: identifier => set({ identifier }),
  setIdentifiers: identifiers => set({ identifiers }),
}));

export default useChartInDialogStore;
